import { render, staticRenderFns } from "./CampusLocations.vue?vue&type=template&id=2d1ba986&scoped=true&"
import script from "./CampusLocations.vue?vue&type=script&lang=ts&"
export * from "./CampusLocations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1ba986",
  null
  
)

export default component.exports